import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { LayoutPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMeta from 'vue-meta'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(LayoutPlugin)
Vue.use(VueMeta)

Vue.use(VueAxios, axios)

axios.defaults.baseURL = process.env.VUE_APP_BACKEND_PROXY;

Vue.component('navbar', require('./components/navbar.vue').default);
Vue.component('sidebar', require('./components/sidebar.vue').default);
Vue.component('judge-footer', require('./components/footer.vue').default);


Vue.config.productionTip = true
Vue.prototype.$bus = new Vue();

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
